import { put, select } from 'redux-saga/effects';
import _ from 'lodash';
import * as actions from '../state';

export default function* deleteChart(event) {
  const chartId = event.payload;

  let charts = yield select((state) => actions.readStateCharts(state));
  charts = charts.map((chart) => {
    const cloned = _.cloneDeep(chart);
    if (String(cloned.id) === String(chartId)) {
      cloned.isDeleted = true; // eslint-disable-line no-param-reassign
    }
    return cloned;
  });

  yield put(actions.setCharts(charts));
  yield put(actions.editMode(true));
  yield put(actions.isDirty(true));
}
